import { Text, Box, Image, Link } from "@chakra-ui/react";

//import style
import { selectStyle } from "../Team Members/dynamic";

//importing project list
import { ProjectList } from "./projects-list";
import { useRef, useEffect } from "react";

//style for select option
const selectBoxStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginTop: "5px",
  marginBottom: "5px",
};

export default function Projects() {
  const refContainer = useRef(null);
  useEffect(() => {
    refContainer.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  return (
    <Box
      id="projects"
      padding="1rem"
      minHeight="100vh"
      marginInlineStart={{ base: "0", md: "0.1rem", xl: "1rem" }}
      ref={refContainer}
    >
      <Box textAlign="center">
        <Text fontSize="3xl" fontWeight={700}>
          Projects
        </Text>
      </Box>

      <Box
        display="flex"
        justifyContent={{
          base: "center",
          md: "space-around",
          lg: "space-around",
        }}
        marginTop="40px"
        flexDir={{ base: "column", md: "row", lg: "row" }}
        alignItems="center"
      >
        <Box style={selectBoxStyle}>
          <Text>Year:</Text>
          <select style={selectStyle}>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
            <option value="2020">2020</option>
            <option value="2019">2019</option>
            <option value="2018">2018</option>
          </select>
        </Box>
        <Box style={selectBoxStyle}>
          <Text>Filter By:</Text>
          <select style={selectStyle}>
            <option value="biomedical">Biomedical</option>
            <option value="electrical">Electrical</option>
            <option value="machine-learning">Machine Learning</option>
            <option value="image-processing">Image Processing</option>
            <option value="artificial-intelligence">
              Artificial Intelligence
            </option>
          </select>
        </Box>
      </Box>

      <Box
        display="flex"
        flexWrap="wrap"
        gap="10px"
        justifyContent={{ base: "center", md: "center", lg: "flex-start" }}
        marginX="auto"
        marginTop="26px"
      >
        {ProjectList.map((item) => {
          return (
            <Box
              key={item.id}
              background="white"
              boxShadow="md"
              width={{ base: "90%", md: "60%", lg: "49%" }}
              display="flex"
              flexDir="column"
            >
              <Box>
                <Image src={item.image} />
              </Box>
              <Box padding="1rem">
                <Text fontSize="26px" fontWeight={700}>
                  {item.title}
                </Text>
                <Text>{item.shortDescription}</Text>
                <Link
                  href={`/projects/${item.slug}`}
                  isExternal
                  _focus={{
                    boxShadow: "none",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    background="#edf0ef"
                    color="black"
                    padding="1rem"
                    width="122px"
                    _hover={{
                      background: "black",
                      color: "white",
                    }}
                    _focus={{
                      textDecoration: "none",
                    }}
                    transition="background 0.2s ease-in"
                  >
                    <Text fontSize="16px">View Project</Text>
                  </Box>
                </Link>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
